import React from 'react';
import {BaseMixin, ElementaryMixin, ContentMixin} from '../common/common.js';
import Glyphicon from './glyphicon.js';

import './panel-header.less';

export default React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    ContentMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Panel.Header',
    classNames: {
      main: 'uu5-bricks-panel-header panel-heading panel-title',
      glyphicon: 'uu5-bricks-panel-glyphicon',
      click: 'uu5-bricks-panel-header-click'
    },
    defaults: {
      parentTagName: 'UU5.Bricks.Panel'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    _glyphicon: React.PropTypes.string,
    _onClick: React.PropTypes.func,
    _disableHeaderClick: React.PropTypes.bool
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      _glyphicon: null,
      _onClick: null,
      _disableHeaderClick: false
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  componentWillMount: function () {
    this.checkParentTagName(this.getDefault().parentTagName);
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _onClickHandler: function (e) {
    !this.props._disableHeaderClick && this.props._onClick(e);
    return this;
  },

  _buildMainAttrs() {
    let mainAttrs = this.buildMainAttrs();
    !this.props._disableHeaderClick && (mainAttrs.className += ' ' + this.getClassName().click);
    return mainAttrs;
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return (
      <div {...this._buildMainAttrs()} onClick={this._onClickHandler}>
        {this.buildChildren()}
        <Glyphicon glyphicon={this.props._glyphicon} className={this.getClassName().glyphicon} />
        {this.getDisabledCover()}
      </div>
    );
  }
  //@@viewOff:render
});



// WEBPACK FOOTER //
// ./bricks/panel-header.js